import React from 'react';
import LeafMark, { Eyebrow } from './LeafMark';

export default function EcoBadgesGrid({ titulo, items }) {
  if (!items?.length) return null;
  return (
    <div style={{ padding: '32px 20px', textAlign: 'center' }}>
      {titulo && <Eyebrow>{titulo}</Eyebrow>}
      <div style={{
        display: 'flex', flexWrap: 'wrap', justifyContent: 'center',
        maxWidth: 620, margin: '0 auto',
      }}>
        {items.map((badge, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '10px 18px',
            borderRight: i < items.length - 1 ? '1px solid rgba(28,58,30,0.12)' : 'none',
          }}>
            <LeafMark size={16} color="var(--sage)" />
            <span style={{ fontFamily: 'var(--font-body)', fontWeight: 600, fontSize: 13.5, color: 'var(--forest)' }}>
              {badge}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
